<template>
  <div class="chiffres">
    <div class="chiffres-header">
      <h1>VOS CHIFFRES</h1>
    </div>

    <div class="kpi-list">

      <div class="kpi-row">
        <div class="kpi-label">
          <img class="kpi-icon" src="@/assets/logoRetardCommande.png" alt="" />
          <span>RETARDS<br />DE COMMANDE</span>
        </div>
        <div class="kpi-value">
          <span class="kpi-number">{{ retard }}</span>
          <router-link class="kpi-link" :to="{ name: 'retards' }">consulter</router-link>
        </div>
      </div>
      <div class="kpi-divider"></div>

      <div class="kpi-row">
        <div class="kpi-label">
          <img class="kpi-icon" src="@/assets/logoRetardCommande.png" alt="" />
          <span>LITIGES<br />DE COMMANDE</span>
        </div>
        <div class="kpi-value">
          <span class="kpi-number">{{ litige }} %</span>
          <router-link v-if="canModif === 1" class="kpi-link" :to="{ name: 'litiges' }">consulter</router-link>
        </div>
      </div>
      <div class="kpi-divider"></div>

      <div class="kpi-row">
        <div class="kpi-label">
          <img class="kpi-icon" src="@/assets/retourencours.png" alt="" />
          <span>RETOURS EN COURS</span>
        </div>
        <div class="kpi-value">
          <span class="kpi-number">{{ retours }}</span>
          <router-link class="kpi-link" :to="{ name: 'retoursEnCours' }">consulter</router-link>
        </div>
      </div>
      <div class="kpi-divider"></div>

      <div class="kpi-row">
        <div class="kpi-label">
          <span>QUALITÉ FOURNISSEURS</span>
        </div>
        <div class="kpi-value">
          <span class="kpi-number">{{ unclosedNC }}</span>
          <router-link class="kpi-link" :to="{ name: 'supplier_quality' }">consulter</router-link>
        </div>
      </div>
      <div class="kpi-divider"></div>

      <div class="kpi-row">
        <div class="kpi-label">
          <img class="kpi-icon" src="@/assets/pretsclients.png" alt="" />
          <span>PRÊTS CLIENTS</span>
        </div>
        <div class="kpi-value">
          <span class="kpi-number">{{ pretsClients }}</span>
          <router-link class="kpi-link" :to="{ name: 'prets' }">consulter</router-link>
        </div>
      </div>
      <div class="kpi-divider"></div>

      <div class="kpi-row">
        <div class="kpi-label">
          <img class="kpi-icon" src="@/assets/priseCommandeJour.png" alt="" />
          <span>PRISE DE COMMANDE<br />HEBDOMADAIRE</span>
        </div>
        <div class="kpi-value">
          <span class="kpi-number">{{ priseCommande.toFixed(1) }} <small>k€</small></span>
        </div>
      </div>
      <div class="kpi-divider"></div>

      <div class="kpi-row">
        <div class="kpi-label">
          <img class="kpi-icon" src="@/assets/priseCommandeJour.png" alt="" />
          <span>EN-COURS MENSUEL</span>
        </div>
        <div class="kpi-value">
          <span class="kpi-number">{{ priseCommandeEnCours.toFixed(1) }} <small>k€</small></span>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import api from "../../api/user";
import apiSupplierQuality from "../../api/supplier_quality";

export default {
  name: "Chiffres",
  data() {
    return {
      priseCommande: 0,
      priseCommandeEnCours: 0,
      retard: 0,
      retours: 0,
      pretsClients: 0,
      litige: 0,
      unclosedNC: 0,
      canModif: 0,
    };
  },
  methods: {
    canModified() {
      if (this.$estAdministrateur()) {
        this.canModif = 1;
      }
    },
  },
  created() {
    api.getChiffres(this.$store.state.AsUser.id_utilisateur || '').then((res) => {
      this.priseCommande = res.data.prise_commande || 0;
      this.priseCommandeEnCours = res.data.priseCommandeEnCours || 0;
      this.retard = res.data.retard || 0;
      this.retours = res.data.retour || 0;
      this.pretsClients = res.data.pretsClients || 0;
      this.litige = res.data.litige > 0 && res.data.litige !== 'null' ? res.data.litige : 0;
    });

    apiSupplierQuality.getUnclosedCount().then((res) => {
      this.unclosedNC = res.data.count || 0;
    });

    this.canModified();
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables";

.chiffres {
  height: 100%;
  display: flex;
  flex-direction: column;
}

// ── Header ─────────────────────────────────────────────────────────
.chiffres-header {
  padding: 16px 16px 12px;

  h1 {
    color: #fff;
    font-size: 1.1rem;
    font-weight: 700;
    letter-spacing: 0.05em;
    margin: 0;
  }
}

// ── KPI list ───────────────────────────────────────────────────────
.kpi-list {
  flex: 1;
  padding: 0 16px 16px;
}

.kpi-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0;
}

.kpi-label {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #fff;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  line-height: 1.4;
  flex: 1;
  min-width: 0;
}

.kpi-icon {
  height: 22px;
  width: auto;
  flex-shrink: 0;
}

.kpi-value {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
  flex-shrink: 0;
}

.kpi-number {
  color: #fff;
  font-size: 1.3rem;
  font-weight: 700;
  line-height: 1;

  small {
    font-size: 0.6em;
    font-weight: 400;
    opacity: 0.8;
  }
}

.kpi-link {
  color: rgba(255, 255, 255, 0.65);
  font-size: 0.68rem;
  font-weight: 400;
  text-decoration: none;
  text-transform: lowercase;
  transition: color 0.15s;

  &:hover {
    color: #fff;
  }
}

.kpi-divider {
  border-top: 1px solid rgba(255, 255, 255, 0.15);
}

// ── Responsive ────────────────────────────────────────────────────
@media screen and (max-width: 1024px) {
  .kpi-number { font-size: 1.1rem; }
}

@media screen and (max-width: 960px) {
  .kpi-number { font-size: 0.95rem; }
  .kpi-label { font-size: 0.7rem; }
}
</style>
